import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "@itaas/core/branding/brand-logo-sizes.css";
import "@itaas/core/branding/module-brand.css";
import "./styles/app.css";
import { SuiteErrorBoundary } from "./components/SuiteErrorBoundary";
import { SuiteProviders } from "./providers/SuiteProviders";
import { AppRouter } from "./router/router";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <SuiteErrorBoundary>
      <SuiteProviders>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
      </SuiteProviders>
    </SuiteErrorBoundary>
  </StrictMode>,
);
